import React, { useState } from 'react';

const ResultProductItem = ({ tag, projectId, product, onAddToCart }) => {
    const [newProdQty, setNewProductQty] = useState(1);

    const numFieldClickHandker = (event) => {
        event.stopPropagation();
    };

    const numFieldValueChangeHandler = (event) => {
        if (event.target.value === '') {
            setNewProductQty(1);
        } else if (parseInt(event.target.value) < 1) {
            setNewProductQty(1);
        } else {
            setNewProductQty(+event.target.value);
        }
    };

    const keyUpHandler = (event) => {
        if (event.key === 'Enter') {
            if (newProdQty > 1) {
                onAddToCart(projectId, tag, product.id, newProdQty);
            }
        }
    };

    return (
        <div className="border-2 border-black-5 p-2 -m-[1px]">
            <div
                key={product.id}
                className="flex items-center"
            >
                <h2 className="text-sm text-black flex-grow">{product.name}</h2>
                <div className="swegon-ui-quantity-input-wrapper w-1/6 pr-4">
                    <input
                        type="number"
                        defaultValue={newProdQty}
                        min={1}
                        onClick={numFieldClickHandker}
                        onChange={numFieldValueChangeHandler}
                        onKeyUp={keyUpHandler}
                    />
                </div>
                <button
                    className="swegon-like-button contained text-sm"
                    onClick={() =>
                        onAddToCart(projectId, tag, product.id, newProdQty)
                    }
                >
                    Add
                </button>
            </div>
        </div>
    );
};

export default ResultProductItem;
